<template>
  <div>
    <!-- popup create subject md-->
    <div
      class="custom-popup-class d-sm-down-none"
      v-if="popupsubjectdetail === true"
      style="z-index: 1"
    >
      <div
        style="
          background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
        "
      >
        <div class="p-3">
          <h3 class="custom-24px text-left text-white mt-2 p-2">
            <img
              src="../assets/img/iconBackWhite.svg"
              class="mr-2"
              @click="CloseSubject()"
            />
            Create New Subject
          </h3>
          <div v-if="popupform === true">
            <div class="p-1">
              <label class="custom-16px text-white">Subject Name</label>
              <input type="text" class="custom-input-user" v-model="Name" />
              <br />
              <CRow>
                <CCol sm="6">
                  <label class="custom-16px text-white mt-3">Grade</label>
                  <v-select
                    v-model="selectedGradeName"
                    :options="gradesName"
                    label="Name"
                    placeholder="--Choose Grade--"
                    class="custom-vselect no-bordered"
                  ></v-select
                ></CCol>
                <CCol sm="6">
                  <label class="custom-16px text-white mt-3">Class</label>
                  <v-select
                    v-model="selectedClassName"
                    :options="classes"
                    label="Name"
                    placeholder="Choose Class"
                    class="custom-vselect no-bordered"
                  >
                  </v-select
                ></CCol>
              </CRow>
              <label class="custom-16px text-white mt-1">Schedule</label>
              <CRow>
                <CCol sm="6">
                  <label class="custom-16px text-white mt-1"
                    >Repeat For Every</label
                  >
                  <input
                    type="number"
                    v-model="interval"
                    class="custom-input-user"
                  />
                </CCol>
                <CCol sm="6">
                  <label class="custom-16px text-white mt-1"
                    >Student Rate</label
                  >
                  <input
                    type="number"
                    placeholder="RM 0"
                    v-model="StudentFee"
                    class="custom-input-user"
                  />
                </CCol>
              </CRow>

              <label class="custom-16px text-white mt-3">Day</label>
              <v-select
                v-model="selectedDay"
                :options="options"
                placeholder="--Please Select Day--"
                class="custom-vselect no-bordered"
                label="dayName"
              ></v-select>

              <CRow>
                <CCol sm="6">
                  <label class="custom-16px text-white mt-3">Start Time</label>
                  <CInput type="datetime-local" v-model="ScheduleDateTime" />
                </CCol>
                <CCol sm="6">
                  <label class="custom-16px text-white mt-3">End Time</label>
                  <CInput type="datetime-local" v-model="ScheduleDateTimeEnd" />
                </CCol>
              </CRow>
              <label class="custom-16px text-white">Theme Color</label>
              <v-select
                v-model="selectedColor"
                :options="optionsColor"
                placeholder="--Please Select Theme--"
                class="custom-vselect no-bordered"
                label="Name"
              ></v-select>

              <label class="custom-16px text-white">Teacher</label>
              <v-select
                v-model="selectedTeacher"
                :options="teachers"
                label="Name"
                placeholder="--Please Select Teacher--"
                class="custom-vselect no-bordered"
              ></v-select>
              <br />
              <div class="text-center">
                <CButton
                  color="primary"
                  size="lg"
                  @click="SubmitSubject()"
                  class="custom-btn-login-active"
                  >Save
                </CButton>
                <br /><br />
              </div>
            </div>
          </div>
          <div v-if="popupsuccess === true">
            <div class="text-center" style="margin-top: 25%">
              <img src="../assets/img/checked.svg" />
              <h3 class="text-white">You're All Set !</h3>
              <label class="text-white">New subject succesfully created!</label>
              <CButton
                size="lg"
                @click="CloseSubject()"
                class="custom-btn-login-active"
                >Close
              </CButton>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- popup create subject sm -->
    <div
      class="custom-popup-class-md d-md-none"
      v-if="popupsubjectdetail === true"
      style="z-index: 1"
    >
      <div
        style="
          background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
        "
      >
        <div>
          <br /><br /><br />
          <h3 class="custom-24px text-left text-white mt-3 p-2">
            <img
              src="../assets/img/iconBack.svg"
              class="mr-2"
              @click="CloseSubject()"
            />
            Create New Subject
          </h3>
          <div
            style="height: 300px; overflow-y: scroll"
            class="mt-5"
            v-if="popupform === true"
          >
            <div class="p-1">
              <label class="custom-16px text-white">Subject Name</label>
              <input type="text" class="custom-input-user" v-model="Name" />
              <br />
              <CRow>
                <CCol sm="6">
                  <label class="custom-16px text-white mt-3">Grade</label>
                  <v-select
                    v-model="selectedGradeName"
                    :options="gradesName"
                    label="Name"
                    placeholder="--Choose Grade--"
                    class="custom-vselect no-bordered"
                  ></v-select
                ></CCol>
                <CCol sm="6">
                  <label class="custom-16px text-white mt-3">Class</label>
                  <v-select
                    v-model="selectedClassName"
                    :options="classes"
                    label="Name"
                    placeholder="Choose Class"
                    class="custom-vselect no-bordered"
                  >
                  </v-select
                ></CCol>
              </CRow>
              <label class="custom-16px text-white mt-1">Schedule</label>
              <CRow>
                <CCol sm="6">
                  <label class="custom-16px text-white mt-1"
                    >Repeat For Every</label
                  >
                  <input
                    type="number"
                    v-model="interval"
                    class="custom-input-user"
                  />
                </CCol>
                <CCol sm="6">
                  <label class="custom-16px text-white mt-1"
                    >Student Rate</label
                  >
                  <input
                    type="number"
                    v-model="StudentFee"
                    class="custom-input-user"
                  />
                </CCol>
              </CRow>

              <label class="custom-16px text-white mt-3">Day</label>
              <v-select
                v-model="selectedDay"
                :options="options"
                placeholder="--Please Select Day--"
                class="custom-vselect no-bordered"
                label="dayName"
              ></v-select>

              <CRow>
                <CCol sm="6">
                  <label class="custom-16px text-white mt-3">Start Time</label>
                  <CInput type="datetime-local" v-model="ScheduleDateTime" />
                </CCol>
                <CCol sm="6">
                  <label class="custom-16px text-white mt-3">End Time</label>
                  <CInput type="datetime-local" v-model="ScheduleDateTimeEnd" />
                </CCol>
              </CRow>
              <label class="custom-16px text-white">Theme Color</label>
              <v-select
                v-model="selectedColor"
                :options="optionsColor"
                placeholder="--Please Select Theme--"
                class="custom-vselect no-bordered"
                label="Name"
              ></v-select>

              <label class="custom-16px text-white">Teacher</label>
              <v-select
                v-model="selectedTeacher"
                :options="teachers"
                label="Name"
                placeholder="--Please Select Teacher--"
                class="custom-vselect no-bordered"
              ></v-select>
              <br />
              <div class="text-center">
                <CButton
                  size="lg"
                  @click="SubmitSubject()"
                  class="custom-btn-login-active"
                  >Save
                </CButton>
                <br /><br />
              </div>
            </div>
          </div>
          <div v-if="popupsuccess === true">
            <div class="text-center" style="margin-top: 25%">
              <img src="../assets/img/checked.svg" />
              <h3 class="text-white">You're All Set !</h3>
              <label class="text-white">New subject succesfully created!</label>
              <CButton
                size="lg"
                @click="CloseSubject()"
                class="custom-btn-login-active"
                >Close
              </CButton>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- popup view subject md -->
    <div
      class="custom-popup-class d-sm-down-none"
      v-if="popupviewsubject === true"
      style="z-index: 1"
    >
      <div
        style="
          background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
        "
      >
        <div class="p-3">
          <h3 class="custom-24px text-left text-white mt-2 p-2">
            <img
              src="../assets/img/iconBackWhite.svg"
              class="mr-2"
              @click="CloseViewSubject()"
            />
            Subject
          </h3>
          <div v-if="updatesubject === true">
            <div class="p-1">
              <label class="custom-16px text-white">Subject Name</label>
              <input
                type="text"
                class="custom-input-user"
                v-model="SubjectNames"
              />
              <br />
              <CRow>
                <CCol sm="6">
                  <label class="custom-16px text-white mt-3">Grade</label>
                  <v-select
                    v-model="SelectedGradeNames"
                    :options="gradesName"
                    label="Name"
                    placeholder="--Choose Grade--"
                    class="custom-vselect no-bordered"
                  ></v-select
                ></CCol>
                <CCol sm="6">
                  <label class="custom-16px text-white mt-3">Class</label>
                  <v-select
                    v-model="SelectedClassNames"
                    :options="classes"
                    label="Name"
                    placeholder="Choose Class"
                    class="custom-vselect no-bordered"
                  >
                  </v-select
                ></CCol>
              </CRow>
              <br />

              <label class="custom-16px text-white mt-1">Student Rate</label>
              <CInput type="number" v-model="StudentFees" />
              <CButton
                class="button mr-2 mt-2 btn-success"
                @click="AddHourRate"
                size="sm"
              >
                <CIcon name="cil-plus" /> Add Teacher New Rate
              </CButton>
              <br />
              <table class="table mt-2 text-white">
                <thead>
                  <th>Hour</th>
                  <th>Rate</th>
                  <th></th>
                </thead>
                <tbody>
                  <tr v-for="item in teacherRate" v-bind:key="item.Id">
                    <td>{{ item.Hour }}</td>
                    <td>{{ item.Rate }}</td>
                    <td>
                      <CButton
                        type="button"
                        class="btn-danger"
                        @click="OpenDeleteTeacherRate(item)"
                        >X</CButton
                      >
                    </td>
                  </tr>
                  <tr
                    v-for="(item, index) in teacherRates"
                    v-bind:key="item.Id"
                  >
                    <td><CInput type="text" v-model="item.Hours" /></td>
                    <td><CInput type="text" v-model="item.Rate" /></td>
                    <td>
                      <button
                        type="button"
                        class="text-center button btn-xs btn-danger"
                        v-on:click="removeRow(index)"
                      >
                        -
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="text-center">
                <CButton
                  size="lg"
                  class="custom-btn-login-active"
                  @click="UpdateSubject(SubjectId)"
                  >Edit
                </CButton>
                <br /><br />
              </div>
            </div>
          </div>
          <div v-if="popupsuccessupdate === true">
            <div class="text-center" style="margin-top: 25%">
              <img src="../assets/img/checked.svg" />
              <h3 class="text-white">You're All Set !</h3>
              <label class="text-white">Edit subject succesfully saved!</label>
              <CButton
                size="lg"
                @click="CloseViewSubject()"
                class="custom-btn-login-active"
                >Close
              </CButton>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- popup view subject sm -->
    <div
      class="custom-popup-class-md d-md-none"
      v-if="popupviewsubject === true"
      style="z-index: 1"
    >
      <div
        style="
          background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
        "
      >
        <div class="p-3">
          <h3 class="custom-24px text-left text-white mt-5 p-2">
            <img
              src="../assets/img/iconBackWhite.svg"
              class="mr-2"
              @click="CloseViewSubject()"
            />
            Subject
          </h3>
          <div
            v-if="updatesubject === true"
            style="height: 300px; overflow-y: scroll"
          >
            <div class="p-1">
              <label class="custom-16px text-white">Subject Name</label>
              <input
                type="text"
                class="custom-input-user"
                v-model="SubjectNames"
              />
              <br />
              <CRow>
                <CCol sm="6">
                  <label class="custom-16px text-white mt-3">Grade</label>
                  <v-select
                    v-model="SelectedGradeNames"
                    :options="gradesName"
                    label="Name"
                    placeholder="--Choose Grade--"
                    class="custom-vselect no-bordered"
                  ></v-select
                ></CCol>
                <CCol sm="6">
                  <label class="custom-16px text-white mt-3">Class</label>
                  <v-select
                    v-model="SelectedClassNames"
                    :options="classes"
                    label="Name"
                    placeholder="Choose Class"
                    class="custom-vselect no-bordered"
                  >
                  </v-select
                ></CCol>
              </CRow>
              <br />

              <label class="custom-16px text-white mt-1">Student Rate</label>
              <CInput type="number" v-model="StudentFees" />
              <CButton
                class="button mr-2 mt-2 btn-success"
                @click="AddHourRate"
                size="sm"
              >
                <CIcon name="cil-plus" /> Add Teacher New Rate
              </CButton>
              <br />
              <table class="table mt-2 text-white">
                <thead>
                  <th>Hour</th>
                  <th>Rate</th>
                  <th></th>
                </thead>
                <tbody>
                  <tr v-for="item in teacherRate" v-bind:key="item.Id">
                    <td>{{ item.Hour }}</td>
                    <td>{{ item.Rate }}</td>
                    <td>
                      <CButton
                        type="button"
                        class="btn-danger"
                        @click="OpenDeleteTeacherRate(item)"
                        >X</CButton
                      >
                    </td>
                  </tr>
                  <tr
                    v-for="(item, index) in teacherRates"
                    v-bind:key="item.Id"
                  >
                    <td><CInput type="text" v-model="item.Hours" /></td>
                    <td><CInput type="text" v-model="item.Rate" /></td>
                    <td>
                      <button
                        type="button"
                        class="text-center button btn-xs btn-danger"
                        v-on:click="removeRow(index)"
                      >
                        -
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="text-center">
                <CButton
                  size="lg"
                  class="custom-btn-login-active"
                  @click="UpdateSubject(SubjectId)"
                  >Edit
                </CButton>
                <br /><br />
              </div>
            </div>
          </div>
          <div v-if="popupsuccessupdate === true">
            <div class="text-center" style="margin-top: 25%">
              <img src="../assets/img/checked.svg" />
              <h3 class="text-white">You're All Set !</h3>
              <label class="text-white">Edit subject succesfully saved!</label>
              <CButton
                size="lg"
                @click="CloseViewSubject()"
                class="custom-btn-login-active"
                >Close
              </CButton>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- popup add package md -->
    <div
      class="custom-popup-class d-sm-down-none"
      v-if="popupcreatepackage === true"
      style="z-index: 1"
    >
      <div
        style="
          background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
        "
      >
        <div class="p-3">
          <h3 class="custom-24px text-left text-white mt-2 p-2">
            <img
              src="../assets/img/iconBackWhite.svg"
              class="mr-2"
              @click="ClosePackage()"
            />
            Create New Package
          </h3>
          <div v-if="addpackage === true">
            <div class="p-1">
              <label class="custom-16px text-white">Package Name</label>
              <input
                type="text"
                class="custom-input-user"
                v-model="PackageName"
              />
              <br />

              <label class="custom-16px text-white mt-2">Description</label>
              <input
                type="text"
                v-model="PackageDescription"
                class="custom-input-user"
              />

              <label class="custom-16px text-white mt-2">Subject</label>
              <v-select
                v-model="selectedSubject"
                :options="subjectsData"
                label="Name"
                placeholder="--Please Select Subject--"
                class="custom-vselect no-bordered"
              ></v-select>

              <div class="text-center mt-3">
                <CButton
                  size="lg"
                  class="custom-btn-login-active"
                  @click="SubmitPackage()"
                  >Save
                </CButton>
                <br /><br />
              </div>
            </div>
          </div>
          <div v-if="popupsuccesspackage === true">
            <div class="text-center" style="margin-top: 25%">
              <img src="../assets/img/checked.svg" />
              <h3 class="text-white">You're All Set !</h3>
              <label class="text-white">New package succesfully saved!</label>
              <CButton
                size="lg"
                @click="ClosePackage()"
                class="custom-btn-login-active"
                >Close
              </CButton>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- popup add package sm -->
    <div
      class="custom-popup-class-md d-md-none"
      v-if="popupcreatepackage === true"
      style="z-index: 1"
    >
      <div
        style="
          background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
        "
      >
        <div class="p-3">
          <h3 class="custom-24px text-left text-white mt-5 p-2">
            <img
              src="../assets/img/iconBackWhite.svg"
              class="mr-2"
              @click="ClosePackage()"
            />
            Subject
          </h3>
          <div
            v-if="addpackage === true"
            style="height: 300px; overflow-y: scroll"
          >
            <div class="p-1">
              <label class="custom-16px text-white">Package Name</label>
              <input
                type="text"
                class="custom-input-user"
                v-model="PackageName"
              />
              <br />

              <label class="custom-16px text-white mt-2">Description</label>
              <input
                type="text"
                v-model="PackageDescription"
                class="custom-input-user"
              />

              <label class="custom-16px text-white mt-2">Subject</label>
              <v-select
                v-model="selectedSubject"
                :options="subjectsData"
                label="Name"
                placeholder="--Please Select Subject--"
                class="custom-vselect no-bordered"
              ></v-select>

              <div class="text-center mt-3">
                <CButton
                  size="lg"
                  class="custom-btn-login-active"
                  @click="SubmitPackage()"
                  >Save
                </CButton>
                <br /><br />
              </div>
            </div>
          </div>
          <div v-if="popupsuccesspackage === true">
            <div class="text-center" style="margin-top: 25%">
              <img src="../assets/img/checked.svg" />
              <h3 class="text-white">You're All Set !</h3>
              <label class="text-white">New package succesfully saved!</label>
              <CButton
                size="lg"
                @click="ClosePackage()"
                class="custom-btn-login-active"
                >Close
              </CButton>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- popup edit package md -->
    <div
      class="custom-popup-class d-sm-down-none"
      v-if="popupupdatepackage === true"
      style="z-index: 1"
    >
      <div
        style="
          background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
        "
      >
        <div class="p-3">
          <h3 class="custom-24px text-left text-white mt-2 p-2">
            <img
              src="../assets/img/iconBackWhite.svg"
              class="mr-2"
              @click="ClosePackageUpdate()"
            />
            Package
          </h3>
          <div v-if="updatepackage === true">
            <div class="p-1">
              <label class="custom-16px text-white">Package Name</label>
              <input
                type="text"
                class="custom-input-user"
                v-model="PackageName"
              />
              <br />

              <label class="custom-16px text-white mt-2">Description</label>
              <input
                type="text"
                v-model="PackageDescription"
                class="custom-input-user"
              />
              <br />
              <br />

              <h6 class="text-white"><strong>ADD ASSIGN SUBJECT</strong></h6>
              <br />
              <CCol sm="12">
                <CRow>
                  <CCol sm="4"> <label class="text-white">Subject</label></CCol>
                  <CCol sm="8">
                    <v-select
                      v-model="selectedSubject"
                      :options="subjects"
                      label="Name"
                      placeholder="--Please Select Subject--"
                    ></v-select>
                  </CCol>
                </CRow>
              </CCol>
              <br />
              <h6 class="text-white"><strong>REMOVE SUBJECT</strong></h6>
              <br />
              <div style="clear: both"></div>
              <CCol sm="12">
                <CDataTable
                  :small="small"
                  :fixed="fixed"
                  :items="FilteredSubjectList"
                  :fields="fieldSubjects"
                  items-per-page-select
                  :items-per-page="small ? 5 : 5"
                  clickable-rows
                  pagination
                  table-filter
                  class="text-white"
                >
                  <template #Name="{ item }">
                    <td>
                      {{ item.Name }}
                    </td>
                  </template>
                  <template #Action="{ item }">
                    <td>
                      <CButton
                        type="button"
                        class="btn btn-danger"
                        @click="OpenDeleteSubjects(item)"
                      >
                        <CIcon name="cil-trash"
                      /></CButton>
                    </td>
                  </template>
                </CDataTable>
              </CCol>

              <div class="text-center mt-3">
                <CButton
                  size="lg"
                  class="custom-btn-login-active"
                  @click="UpdatePackage(PackageId)"
                  >Save
                </CButton>
                <br /><br />
              </div>
            </div>
          </div>
          <div v-if="popupsuccessupdatepackage === true">
            <div class="text-center" style="margin-top: 25%">
              <img src="../assets/img/checked.svg" />
              <h3 class="text-white">You're All Set !</h3>
              <label class="text-white">Edit package succesfully saved!</label>
              <CButton
                size="lg"
                @click="ClosePackageUpdate()"
                class="custom-btn-login-active"
                >Close
              </CButton>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- popup edit package sm -->
    <div
      class="custom-popup-class-md d-md-none"
      v-if="popupcreatepackage === true"
      style="z-index: 1"
    >
      <div
        style="
          background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
        "
      >
        <div class="p-3">
          <h3 class="custom-24px text-left text-white mt-5 p-2">
            <img
              src="../assets/img/iconBackWhite.svg"
              class="mr-2"
              @click="ClosePackageUpdate()"
            />
            Subject
          </h3>
          <div
            v-if="addpackage === true"
            style="height: 300px; overflow-y: scroll"
          >
            <div class="p-1">
              <label class="custom-16px text-white">Package Name</label>
              <input
                type="text"
                class="custom-input-user"
                v-model="PackageName"
              />
              <br />

              <label class="custom-16px text-white mt-2">Description</label>
              <input
                type="text"
                v-model="PackageDescription"
                class="custom-input-user"
              />

              <h6><strong>ADD ASSIGN SUBJECT</strong></h6>
              <br />
              <CCol sm="12">
                <CRow>
                  <CCol sm="4"> Subject</CCol>
                  <CCol sm="8">
                    <v-select
                      v-model="selectedSubject"
                      :options="subjects"
                      label="Name"
                      placeholder="--Please Select Subject--"
                    ></v-select>
                  </CCol>
                </CRow>
              </CCol>
              <br />
              <h6><strong>REMOVE SUBJECT</strong></h6>
              <br />
              <div style="clear: both"></div>
              <CCol sm="12">
                <CDataTable
                  :small="small"
                  :fixed="fixed"
                  :items="FilteredSubjectList"
                  :fields="fieldSubjects"
                  items-per-page-select
                  :items-per-page="small ? 5 : 5"
                  clickable-rows
                  pagination
                  table-filter
                >
                  <template #Name="{ item }">
                    <td>
                      {{ item.Name }}
                    </td>
                  </template>
                  <template #Action="{ item }">
                    <td>
                      <CButton
                        type="button"
                        class="btn btn-danger"
                        @click="OpenDeleteSubjects(item)"
                      >
                        <CIcon name="cil-trash"
                      /></CButton>
                    </td>
                  </template>
                </CDataTable>
              </CCol>

              <div class="text-center mt-3">
                <CButton
                  size="lg"
                  class="custom-btn-login-active"
                  @click="UpdatePackage(PackageId)"
                  >Save
                </CButton>
                <br /><br />
              </div>
            </div>
          </div>
          <div v-if="popupsuccessupdatepackage === true">
            <div class="text-center" style="margin-top: 25%">
              <img src="../assets/img/checked.svg" />
              <h3 class="text-white">You're All Set !</h3>
              <label class="text-white">Edit package succesfully saved!</label>
              <CButton
                size="lg"
                @click="ClosePackageUpdate()"
                class="custom-btn-login-active"
                >Close
              </CButton>
            </div>
          </div>
        </div>
      </div>
    </div>

    <h3 class="header-title">
      <img src="../assets/img/iconBack.svg" class="mr-2" />Learning
    </h3>
    <label>Let’s see your tuition progress.</label>
    <br />
    <CRow class="mt-1">
      <CCol sm="12">
        <CTabs class="m-2">
          <CTab title="Subject" active>
            <br />
            <CRow>
              <CCol sm="10">
                <CInput
                  type="text"
                  placeholder="Seacrh for subjects"
                  v-model.lazy="SearchQuery"
                />
              </CCol>
              <CCol sm="2">
                <CButton
                  type="button"
                  class="custom-bg-blue float-right mr-4 mb-2"
                  @click="OpenSubject()"
                  >+ Create
                </CButton></CCol
              >
            </CRow>

            <div style="clear: both"></div>
            <CCol sm="12">
              <div>
                <CCard class="custom-explore text-white p-3 m-2 d-sm-down-none">
                  <CRow>
                    <CCol sm="2">SubjectName</CCol>
                    <CCol sm="2">Schedule</CCol>
                    <CCol sm="2">Period</CCol>
                    <CCol sm="2">Teacher</CCol>
                    <CCol sm="2">Teacher Rate</CCol>
                    <CCol sm="2">Student Fee</CCol>
                  </CRow>
                </CCard>
                <div v-if="Busy == true">
                  <CCol sm="12" md="12">
                    <div class="app flex-row align-items-center">
                      <div class="container d-flex justify-content-center">
                        <PulseLoader float />
                      </div>
                    </div>
                  </CCol>
                </div>
                <div v-else>
                  <div>
                    <CCol sm="12">
                      <CCard
                        v-for="item in FilteredSubjectsList"
                        v-bind:key="item.SubjectId"
                        class="p-2 custom-box-shadow"
                      >
                        <CRow>
                          <CCol sm="2">
                            <label>
                              <label class="d-md-none">Subject Name : </label>
                              <b class="text-custom-primary">{{
                                item.SubjectName
                              }}</b>
                              <br />
                              <b>Grade:</b> {{ item.Grade }} <br />
                              <b>Class:</b> {{ item.ClassName }}
                            </label>
                          </CCol>
                          <CCol sm="2">
                            <label class="d-md-none">Schedule : </label>
                            <tr
                              v-for="weeks in item.WeeklySchedules"
                              v-bind:key="weeks.Id"
                            >
                              <li>
                                {{ weeks.ScheduleTime | moment("DD/MM/YYYY") }}
                                ({{ weeks.ScheduleTime | moment("HH:mm") }} -
                                {{ weeks.ScheduleTimeEnd | moment("HH:mm") }})
                              </li>
                            </tr>
                          </CCol>
                          <CCol sm="2">
                            <label class="d-md-none">Period : </label></CCol
                          >
                          <CCol sm="2">
                            <label class="d-md-none">Teacher: </label>
                            <tr
                              v-for="tea in item.Teachers"
                              v-bind:key="tea.Id"
                            >
                              <li>{{ tea.Name }}</li>
                            </tr>
                          </CCol>
                          <CCol sm="2">
                            <label class="d-md-none">Teacher Rate : </label>
                            <tr
                              v-for="rate in item.RateTeacher"
                              v-bind:key="rate.Id"
                            >
                              <li>{{ rate.Hour }} hour : RM {{ rate.Rate }}</li>
                            </tr>
                          </CCol>
                          <CCol sm="2">
                            <div class="float-left">
                              <label class="d-md-none">Student Rate : </label>
                              {{ item.StudentFee }}
                            </div>
                            <div class="float-right">
                              <CDropdown color="link" size="lg" :caret="false">
                                <template #toggler-content>
                                  <img src="../assets/img/dots-vertical.svg" />
                                </template>
                                <CDropdownItem @click="OpenUpdate(item)"
                                  >View</CDropdownItem
                                >
                                <CDropdownItem @click="OpenUpdate(item)"
                                  >Edit</CDropdownItem
                                >
                                <CDropdownItem @click="OpenRemove(item)"
                                  >Remove</CDropdownItem
                                >
                              </CDropdown>
                            </div>
                          </CCol>
                        </CRow>
                      </CCard>
                    </CCol>
                  </div>
                  <!-- <jw-pagination
                  :items="FilteredSubjects"
                  @changePage="onChangePage"
                  :labels="customLabels"
                ></jw-pagination> -->
                </div>
              </div>
            </CCol>

            <div v-if="popupremovesubject === true">
              <div id="overlay">
                <div class="custom-card-fixed-center">
                  <CContainer
                    data-aos="fade-up"
                    class="custom-card-default p-3 text-center"
                  >
                    <h5>
                      <strong>Remove Subject?</strong
                      ><span class="float-right" @click="ClosePopup()">X</span>
                    </h5>
                    Are you sure you want to remove <br />
                    {{ SubjectNames }}
                    subject ?
                    <br />
                    <br />
                    <CButton
                      class="btn-blue-primary"
                      size="sm"
                      block
                      @click="DeleteSubjects(SubjectId)"
                    >
                      Confirm
                    </CButton>
                    <CButton
                      class="btn-default-white"
                      size="sm"
                      block
                      @click="ClosePopup()"
                    >
                      Cancel
                    </CButton>
                  </CContainer>
                </div>
              </div>
            </div>
          </CTab>
          <CTab title="Packages">
            <br />
            <CRow>
              <CCol sm="10">
                <CInput
              type="text"
              placeholder="Seacrh for packages"
              v-model.lazy="SearchQueryPackage"
            />
              </CCol>
              <CCol sm="2">
                <CButton
                  type="button"
                  class="custom-bg-blue float-right mr-4 mb-2"
                  @click="OpenPackage()"
                  >+ Create
                </CButton></CCol
              >
            </CRow>
            <div>
              <CCard class="custom-explore text-white p-3 m-2 d-sm-down-none">
                <CRow>
                  <CCol sm="2">Package Name</CCol>
                  <CCol sm="4">Description</CCol>
                  <CCol sm="2">Subjects</CCol>
                  <CCol sm="2">Total Student</CCol>
                  <CCol sm="2"></CCol>
                </CRow>
              </CCard>

               <div v-if="Busy == true">
                  <CCol sm="12" md="12">
                    <div class="app flex-row align-items-center">
                      <div class="container d-flex justify-content-center">
                        <PulseLoader float />
                      </div>
                    </div>
                  </CCol>
                </div>
                <div v-else>
              <div>
                <CCol sm="12">
                  <CCard
                    v-for="item in FilteredPackagesList"
                    v-bind:key="item.Id"
                    class="p-2 custom-box-shadow"
                  >
                    <CRow>
                      <CCol sm="2">
                        <label>
                          <label class="d-md-none">Package Name : </label>
                          <b class="text-custom-primary">{{ item.Name }}</b>
                        </label>
                      </CCol>
                      <CCol sm="4">
                        {{ item.Description }}
                      </CCol>
                      <CCol sm="2">
                        <label class="d-md-none">Subject : </label>
                        <tr v-for="su in item.Subject" v-bind:key="su.Id">
                          <li>{{ su.Name }} ( {{ su.Rate }} )</li>
                        </tr>
                      </CCol>
                      <CCol sm="2">
                        <label class="d-md-none">Total Student : </label>
                        {{ item.TotalStudent }}
                      </CCol>
                      <CCol sm="2">
                        <div class="float-right">
                          <CDropdown color="link" size="lg" :caret="false">
                            <template #toggler-content>
                              <img src="../assets/img/dots-vertical.svg" />
                            </template>
                            <CDropdownItem @click="OpenUpdatePackage(item)"
                              >View</CDropdownItem
                            >
                            <CDropdownItem @click="OpenUpdatePackage(item)"
                              >Edit</CDropdownItem
                            >
                            <CDropdownItem @click="OpenRemovePackage(item)"
                              >Remove</CDropdownItem
                            >
                          </CDropdown>
                        </div>
                      </CCol>
                    </CRow>
                  </CCard>

                  <!-- <jw-pagination
                    :items="FilteredPackages"
                    @changePage="onChangePagePackage"
                    :labels="customLabels"
                  ></jw-pagination> -->
                </CCol>
              </div>
              </div>
            </div>
            <div v-if="popupremovepackage === true">
              <div id="overlay">
                <div class="custom-card-fixed-center">
                  <CContainer
                    data-aos="fade-up"
                    class="custom-card-default p-3 text-center"
                  >
                    <h5>
                      <strong>Remove Package?</strong
                      ><span
                        class="float-right"
                        @click="ClosePopupRemovePackage()"
                        >X</span
                      >
                    </h5>
                    Are you sure you want to remove <br />
                    {{ PackageName }}
                    package ?
                    <br />
                    <br />
                    <CButton
                      class="btn-blue-primary"
                      size="sm"
                      block
                      @click="DeletePackage(PackageId)"
                    >
                      Confirm
                    </CButton>
                    <CButton
                      class="btn-default-white"
                      size="sm"
                      block
                      @click="ClosePopupRemovePackage()"
                    >
                      Cancel
                    </CButton>
                  </CContainer>
                </div>
              </div>
            </div>
          </CTab>
        </CTabs>
      </CCol>
    </CRow>
  </div>
</template>

  
<script>
import Vue from "vue";
import FullCalendar from "vue-full-calendar";
import "fullcalendar/dist/fullcalendar.css";
import backgroundUrl from "../assets/img/bgtips.png";
import moment from "moment";
Vue.use(require("vue-moment"));

import _ from "lodash";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { CChartBar } from "@coreui/vue-chartjs";
import VueEllipseProgress from "vue-ellipse-progress";

//import "@fullcalendar/core/vdom"; // solves problem with Vite]

import { Calendar } from "vue-sweet-calendar";
import "vue-sweet-calendar/dist/SweetCalendar.css";
import vSelect from "vue-select";
import JwPagination from "jw-vue-pagination";
Vue.component("jw-pagination", JwPagination);

Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

Vue.use(FullCalendar);
Vue.use(VueEllipseProgress);

const customLabels = {
  first: "<<",
  last: ">>",
  previous: "<",
  next: ">",
};
export default {
  name: "Collapses",
  components: {
    PulseLoader,
    CChartBar,
    Calendar,
  },
  data() {
    return {
      Busy: false,
      customLabels,
      SearchQuery: "",
      backgroundUrl,
      user: {},
      subjects: [],
      FilteredSubjects: [],
      FilteredPackages: [],
      packages: [],
      respond: [],
      waiting: [],
      popupsubjectdetail: false,

      gradesName: [],
      classes: [],
      teachers: [],

      Name: "",
      selectedGradeName: "",
      selectedClassName: "",
      ScheduleDateTime: "",
      ScheduleDateTimeEnd: "",
      selectedDay: "",
      ScheduleTime: "",
      ScheduleTimeEnd: "",
      interval: 0,
      StudentFee: 0,

      selectedTeacher: "",
      selectedColor: "",
      options: [
        {
          Id: 1,
          dayName: "Monday",
        },
        {
          Id: 2,
          dayName: "Tuesday",
        },
        {
          Id: 3,
          dayName: "Wednesday",
        },
        {
          Id: 4,
          dayName: "Thursday",
        },
        {
          Id: 5,
          dayName: "Friday",
        },
        {
          Id: 6,
          dayName: "Saturday",
        },
        {
          Id: 7,
          dayName: "Sunday",
        },
      ],
      optionsColor: [
        {
          Id: 1,
          Name: "blue",
        },
        {
          Id: 2,
          Name: "red",
        },
        {
          Id: 3,
          Name: "green",
        },
        {
          Id: 4,
          Name: "purple",
        },
        {
          Id: 5,
          Name: "violet",
        },
      ],
      popupsuccess: false,
      popupform: true,

      SelectedGradeNames: {},
      SelectedClassNames: {},
      StudentFees: "",
      SubjectNames: "",
      popupviewsubject: false,

      teacherRates: [],
      updatesubject: true,
      popupsuccessupdate: false,
      popupremovesubject: false,

      popupcreatepackage: false,
      addpackage: true,

      PackageName: "",
      PackageDescription: "",
      selectedSubject: "",
      subjectsData: [],
      popupsuccesspackage: false,
      addpackage: true,

      popupupdatepackage: false,
      updatepackage: false,
      popupsuccessupdatepackage: false,

      FilteredSubjectList: [],
      fieldSubjects: [{ key: "Name" }, { key: "Action" }],

      popupremovepackage: false,
      SearchQueryPackage: "",

        currentPage: 1,
        itemsPerPage: 10,
    };
  },
  created() {},
  async mounted() {
    this.SessionUserIdNo();
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetSubject();
      this.GetClass();
      this.GetGrade();
      this.GetTeacher();
      this.GetPackage();
    } else {
      this.GoToLogin();
    }
  },
  computed: {
    FilteredSubjectsList() {
      if (this.SearchQuery === "") return this.FilteredSubjects;
      return this.FilteredSubjects.filter((item) => {
        //teacher name
        for (const { Name } of item.Teachers) {
          if (Name.toLowerCase().indexOf(this.SearchQuery.toLowerCase()) > -1) {
            return item;
          }
        }

        //teacher rate
        for (const { Hour, Rate } of item.RateTeacher) {
          if (
            Hour.toString().indexOf(this.SearchQuery.toString()) > -1 ||
            Rate.toString().indexOf(this.SearchQuery.toString()) > -1
          ) {
            return item;
          }
        }

        //schedule
        for (const { ScheduleTime, ScheduleTimeEnd } of item.WeeklySchedules) {
          if (
            ScheduleTime.toString().indexOf(this.SearchQuery.toString()) > -1 ||
            ScheduleTimeEnd.toString().indexOf(this.SearchQuery.toString()) > -1
          ) {
            return item;
          }
        }

        //subject name
        if (
          item.SubjectName.toLowerCase().indexOf(
            this.SearchQuery.toLowerCase()
          ) > -1
        ) {
          return item;
        }

        //Grade name
        if (
          item.Grade.toLowerCase().indexOf(this.SearchQuery.toLowerCase()) > -1
        ) {
          return item;
        }

        //Class name
        if (
          item.ClassName.toLowerCase().indexOf(this.SearchQuery.toLowerCase()) >
          -1
        ) {
          return item;
        }

        //student fee
        const fee = item.StudentFee?.toString() || "";
        if (fee.indexOf(this.SearchQuery.toString()) > -1) {
          return item;
        }
      });
    },
    FilteredPackagesList() {
      if(this.SearchQueryPackage === '') return this.FilteredPackages
      return this.FilteredPackages.filter(item => {   
        //teacher name     
        for (const {Name} of item.Subject) {
          if (
            Name.toLowerCase().indexOf(this.SearchQueryPackage.toLowerCase()) > -1 
          ) {
            return item
          }
        }

          if (
            item.Name.toLowerCase().indexOf(this.SearchQueryPackage.toLowerCase()) > -1 
          ) {
            return item
          }

      })
    },

  },

  methods: {
    OpenUpdate(item) {
      this.subjectId = item.SubjectId;

      this.$API
        .get(this.$GetRateTeacherById + "?id=" + this.subjectId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.teacherRate = response.data;
          }
        });

      this.$API
        .get(this.$GetSubjectById + "?id=" + this.subjectId, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;
          if (response.status == 200 && this.info != null) {
            this.SubjectNames = this.info.SubjectName;
            this.GradeNames = this.info.Grade;
            this.ClassNames = this.info.ClassName;
            this.StudentFees = this.info.StudentFee;
            this.SubjectId = this.info.SubjectId;

            this.SetupSelectedOption();
          }
        });

      this.popupviewsubject = true;
      this.updatesubject = true;
      this.popupsuccessupdate = false;
    },
    SetupSelectedOption() {
      this.SelectedGradeNames = _.find(this.gradesName, {
        Name: this.GradeNames,
      });
      this.SelectedClassNames = _.find(this.classes, {
        Name: this.ClassNames,
      });
    },
    onChangePage(subjects) {
      // update page of items
      this.subjects = subjects;
    },
    onChangePagePackage(packages) {
      // update page of items
      this.packages = packages;
    },

    SessionUserIdNo() {
      return this.$API
        .get(this.$LoginUserDetailAdmin, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetSubject();
            this.GetClass();
            this.GetGrade();
            this.GetTeacher();
            this.GetPackage();
          }
        });
    },

    GetSubject() {
      this.Busy = true;
      this.$API
        .get(this.$ViewSubject, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.subjects = response.data;
            this.FilteredSubjects = this.subjects;
          }
        });
    },
    GetPackage() {
      this.Busy = true;
      this.$API
        .get(this.$ViewPackage, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.packages = response.data;
            this.FilteredPackages = this.packages;
          }
        });
    },
    GetClass() {
      this.$API
        .get(this.$ListClassTc, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.classes = response.data;
          }
        });
    },

    GetGrade() {
      this.$API
        .get(this.$ListGradeTc, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.gradesName = response.data;
          }
        });
    },
    GetTeacher() {
      this.$API
        .get(this.$ViewTeacher, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.teachers = response.data;
          }
        });
    },
    async SubmitSubject() {
      this.Error = false;
      this.Busy = true;
      const formData = new FormData();

      formData.append("Name", this.Name);
      formData.append("Grade", this.selectedGradeName.Name);
      formData.append("ClassName", this.selectedClassName.Name);

      formData.append("StudentFee", this.StudentFee);
      return this.$API
        .post(this.$InsertNewSubjectTcAdmin, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.SubjectId = response.data;
            const formData = new FormData();

            formData.append("TuitionSubjectId", this.SubjectId);

            formData.append("ScheduleDay", this.selectedDay.dayName);
            formData.append("ScheduleDateTime", this.ScheduleDateTime);

            formData.append("ScheduleDateTimeEnd", this.ScheduleDateTimeEnd);

            formData.append("TeacherId", this.selectedTeacher.Id);
            formData.append("ThemeColor", this.selectedColor.Name);

            formData.append("interval", this.interval);
            return this.$API
              .post(this.$InsertSchedule, formData, {
                withCredentials: true,
              })
              .then((response) => {
                if (response.status == 200) {
                  this.Busy = false;
                  this.popupsuccess = true;
                  this.popupform = false;
                } else {
                  this.Busy = false;
                  this.$dialog.alert("Error to save ").then(function () {});
                }
              })
              .catch((error) => {
                this.Busy = false;
                this.Loading = false;
                this.Error = true;
                this.Message = error.response.data.message;
              });
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to create subject ").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },
    async CreateSchedule(SubjectId) {
      this.TuitionSubjectId = SubjectId;

      if (
        this.StartDate === "" ||
        this.EndDate === "" ||
        this.selectedDay.dayName === "" ||
        this.StartTime === "" ||
        this.EndTime === ""
      ) {
        this.Error = true;
        this.Message = "Please Complete all the forms";
      } else {
        this.Error = false;
        this.Busy = true;
        const formData = new FormData();

        formData.append("TuitionSubjectId", this.SubjectId);
        formData.append(
          "StartDate",
          moment(this.ScheduleTime).format("YYYY-MM-DD")
        );
        formData.append(
          "EndDate",
          moment(this.ScheduleTimeEnd).format("YYYY-MM-DD")
        );

        formData.append("ScheduleDay", this.selectedDay.dayName);
        formData.append(
          "ScheduleTime",
          moment(this.ScheduleTime).format("hh:mm A")
        );

        formData.append(
          "ScheduleTimeEnd",
          moment(this.ScheduleTimeEnd).format("hh:mm A")
        );

        return this.$API
          .post(this.$InsertNewScheduleBySubId, formData, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200) {
              this.popupsubjectdetail = false;
              this.popupsuccess = true;
            } else {
              this.Busy = false;
              this.$dialog.alert("Error to save ").then(function () {});
            }
          })
          .catch((error) => {
            this.Busy = false;
            this.Loading = false;
            this.Error = true;
            this.Message = error.response.data.message;
          });
      }
    },
    OpenSubject() {
      this.popupsubjectdetail = true;
      this.popupsuccessupdate = false;
      this.updatesubject = true;
    },
    CloseSubject() {
      this.popupsubjectdetail = false;
      this.$forceUpdate();
    },
    CloseViewSubject() {
      this.popupviewsubject = false;
    },
    UpdateSubject: function () {
      const formData = new FormData();
      formData.append("Id", this.SubjectId);
      formData.append("Name", this.SubjectNames);
      formData.append("Grade", this.SelectedGradeNames.Name);
      formData.append("ClassName", this.SelectedClassNames.Name);

      formData.append("StudentFee", this.StudentFees);

      var teacherRateData = JSON.stringify(this.teacherRates);
      formData.append("teacherRatesJson", teacherRateData);

      return this.$API
        .post(this.$UpdateTuitionSubject, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.popupsuccessupdate = true;
            this.updatesubject = false;
          } else {
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },
    AddHourRate() {
      var lastId = 1;
      var length = this.teacherRates.length;
      if (length > 0) lastId = this.teacherRates[length - 1].Id;

      this.teacherRates.push({
        Id: lastId + 1,
        Hours: 1,
        Rate: 1,
      });
    },
    removeRow: function (index) {
      this.teacherRates.splice(index, 1);
    },
    OpenRemove(item) {
      this.subjectId = item.SubjectId;

      this.$API
        .get(this.$GetSubjectById + "?id=" + this.subjectId, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;
          if (response.status == 200 && this.info != null) {
            this.SubjectNames = this.info.SubjectName;
            this.SubjectId = this.info.SubjectId;
          }
        });

      this.popupremovesubject = true;
    },
    DeleteSubjects(SubjectId) {
      const formData = new FormData();

      formData.append("Id", SubjectId);

      return this.$API
        .post(this.$DeleteSubject, formData, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;

          if (response.status == 200) {
            this.popupremovesubject = false;
            this.$forceUpdate();
          } else console.log("Error Deleting");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    ClosePopup() {
      this.popupremovesubject = false;
    },
    OpenPackage() {
      this.popupcreatepackage = true;
      this.popupsuccesspackage = false;
      this.$API
        .get(this.$GetListSubjectTc, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.subjectsData = response.data;
          }
        });
    },
    async SubmitPackage() {
      this.Busy = true;
      const formData = new FormData();

      formData.append("Name", this.PackageName);
      formData.append("Description", this.PackageDescription);

      return this.$API
        .post(this.$InsertPackage, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.PackageId = response.data;
            this.CreateAssignSubject(this.PackageId);
          } else {
            this.Busy = false;
            this.$dialog
              .alert("Error to create packagess")
              .then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },
    async CreateAssignSubject(PackageId) {
      this.TuitionPackageId = PackageId;

      const formData = new FormData();

      formData.append("TuitionSubjectId", this.selectedSubject.SubjectId);
      formData.append("TuitionPackageId", this.TuitionPackageId);

      return this.$API
        .post(this.$InsertAssignSubject, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.popupsuccesspackage = true;
            this.addpackage = false;
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to save ").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },
    ClosePackage() {
      this.popupcreatepackage = false;
      this.addpackage = false;
    },
    OpenUpdatePackage(item) {
      this.packageId = item.Id;

      this.$API
        .get(this.$GetPackageById + "?id=" + this.packageId, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;
          if (response.status == 200 && this.info != null) {
            this.PackageName = this.info.Name;
            this.PackageDescription = this.info.Description;
          }
        });

      this.$API
        .get(this.$GetListSubjectTc, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.subjects = response.data;
          }
        });
      this.$API
        .get(this.$GetListSubjectPackageTc + "?id=" + this.packageId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.subjectsList = response.data;
            this.FilteredSubjectList = this.subjectsList;
          }
        });

      this.popupupdatepackage = true;
      this.updatepackage = true;
      this.popupsuccessupdatepackage = false;
    },
    UpdatePackage: function () {
      const formData = new FormData();
      formData.append("Id", this.packageId);
      formData.append("Name", this.PackageName);
      formData.append("Description", this.PackageDescription);

      return this.$API
        .post(this.$UpdateTuitionPackage, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.updatepackage = false;
            this.popupsuccessupdatepackage = true;
            this.CreateAssignSubject(this.packageId);
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to update package ").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },
    ClosePackageUpdate() {
      this.popupupdatepackage = false;
      this.popupsuccessupdatepackage = false;
    },
    OpenDeleteSubjects(item) {
      const formData = new FormData();

      formData.append("Id", item.SubjectId);

      return this.$API
        .post(this.$DeleteSubjectTuitionPackage, formData, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;

          if (response.status == 200) {
          } else console.log("Error Deleting");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async CreateAssignSubject(PackageId) {
      this.TuitionPackageId = PackageId;

      const formData = new FormData();

      formData.append("TuitionSubjectId", this.selectedSubject.SubjectId);
      formData.append("TuitionPackageId", this.TuitionPackageId);

      return this.$API
        .post(this.$InsertAssignSubject, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.updatepackage = false;
            this.popupsuccessupdatepackage = true;
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to save ").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },
    OpenRemovePackage(item) {
      this.popupremovepackage = true;
      this.packageId = item.Id;
      this.$API
        .get(this.$GetPackageById + "?id=" + this.packageId, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;
          if (response.status == 200 && this.info != null) {
            this.PackageName = this.info.Name;
            this.PackageDescription = this.info.Description;
            this.PackageId = this.info.PackageId;
          }
        });
    },
    DeletePackage(PackageId) {
      const formData = new FormData();

      formData.append("Id", PackageId);

      return this.$API
        .post(this.$DeleteTuitionPackage, formData, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;

          if (response.status == 200) {
            this.popupremovepackage = false;
          } else console.log("Error Deleting");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    ClosePopupRemovePackage() {
      this.popupremovepackage = false;
    },
    ApplyFilter: function () {
      var arr = _.orderBy(this.subjects, ["SubjectName"], ["asc"]);
      if (_.isEmpty(arr) == false) {
        const result = _.filter(arr, ({ SubjectName, Grade, ClassName }) =>
          _.some([
            _.includes(!SubjectName || SubjectName.toLowerCase(), [
              this.SearchQuery.toLowerCase(),
            ]),
            _.includes(!Grade || Grade.toLowerCase(), [
              this.SearchQuery.toLowerCase(),
            ]),
            _.includes(!ClassName || ClassName.toLowerCase(), [
              this.SearchQuery.toLowerCase(),
            ]),
          ])
        );
        this.FilteredSubjects = result;
      }
    },
  },
};
</script>
<link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@100&family=Rubik:ital,wght@0,300;0,400;1,300;1,400&display=swap" rel="stylesheet"></link>
  <style scoped>
.c-app {
  /* font-family: montserrat, Sans-serif; */
  font-family: 'Rubik', sans-serif !important;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #321fdb;
  background-color: none;
  border-bottom: 2px solid #eee;
}

input {
  border-bottom: 2px solid #fff;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  -webkit-text-fill-color: white !important;
  width: 100% !important;
}
input[type="date"] {
  border-bottom: 2px solid #fff;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  -webkit-text-fill-color: white !important;
  width: 100% !important;
}
input .custom-user-input-select {
  border-bottom: 2px solid #fff;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
}

.custom-bordered .table thead tr {
  background: green;
}
.custom-bordered.table-responsive.table thead tr th {
  background: red;
}

.custom-bordered.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid;
  border-bottom-color: #d8dbe0;
  background: antiquewhite;
}

.v-select.custom-vselect.no-bordered.vs--single.vs--searchable {
  cursor: text;
  border-bottom: 2px solid #fff;
  border-top: none;
  border-right: none;
  border-left: none;
}
.v-select.custom-vselect.no-bordered.vs--single.vs--searchable.vs__dropdown-toggle {
  border: none !important;
}
.vs__dropdown-toggle {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding: 0 0 4px 0;
  background: none;
  border: none !important;
  border-radius: 4px;
  white-space: normal;
}

#overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2;
  overflow-y: scroll;
}
.custom-card-fixed-center {
  position: absolute;
  top: 100px;
  margin: 0 auto;
  left: 0;
  right: 0;
  float: none;
}
.custom-card-default {
  background: #fff;
  width: 20%;
  border-radius: 20px;
}
</style>
    
